import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Vyaghrasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Vyaghrasana.title1"), context: t("Vyaghrasana.context1") },
      { title: t("Vyaghrasana.title2"), context: t("Vyaghrasana.context2") },
      { title: t("Vyaghrasana.title3"), context: t("Vyaghrasana.context3") },
      { title: t("Vyaghrasana.title4"), context: t("Vyaghrasana.context4") },
      { title: t("Vyaghrasana.title5"), context: t("Vyaghrasana.context5") },
      { title: t("Vyaghrasana.title6"), context: t("Vyaghrasana.context6") },
      { title: t("Vyaghrasana.title7"), context: t("Vyaghrasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Vyaghrasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/vyagrasana+yoga.mp4'}
                title="Description"
                context={t("Vyaghrasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Vyaghrasana
